import {createSlice, PayloadAction, Slice, SliceSelectors} from '@reduxjs/toolkit';

export interface PasswordDialogState {
  open: boolean;
  onConfirm: (input: string) => void;
}

const initialState: PasswordDialogState = {
  open: false,
  onConfirm: () => {},
};

const passwordDialogSlice: Slice<PasswordDialogState, {
  close: (state: any) => void;
  open: (state: any, action: PayloadAction<(input: string) => void>) => void
}, string, string, SliceSelectors<PasswordDialogState>> = createSlice({
  name: 'passwordDialog',
  initialState,
  reducers: {
    open: (state, action: PayloadAction<(input: string) => void>) => {
      state.open = true;
      state.onConfirm = action.payload;
    },
    close: (state) => {
      state.open = false;
    },
  },
});

export default passwordDialogSlice;
